import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { CFSummaryResponse } from 'api/ControllingApi';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

export async function getCFSSummary(axios: AxiosInstance): Promise<CFSummaryResponse> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/controlling/cashflow-end-of-month`);
  return data;
}

export default function useCashFlowSummaryQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getCFSSummary(axios),
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['CashFlowSummary'] as const satisfies QueryKey;
}
useCashFlowSummaryQuery.getKey = getKey;
